var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LazyEmitter } from './RenderThread';
/**
 * 核心编排抽象类，
 * 所有需要编排模型的渲染引擎需要来实现它
 */
var CoreModel = /** @class */ (function (_super) {
    __extends(CoreModel, _super);
    function CoreModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreModel.prototype.getConsultModel = function () {
        return this.consultModel;
    };
    CoreModel.prototype.getHeaderModel = function () {
        return this.headerModel;
    };
    CoreModel.prototype.getLeaveModel = function () {
        return this.leaveModel;
    };
    CoreModel.prototype.getMessageModel = function () {
        return this.messageModel;
    };
    CoreModel.prototype.getMobileModel = function () {
        return this.mobileModel;
    };
    CoreModel.prototype.onUpdate = function () { };
    return CoreModel;
}(LazyEmitter));
export { CoreModel };
